module.exports = __webpack_public_path__ + "media/images/common/notice_mark-d65a1b1346454cd565f7ec38cbb17635.png";